import { useLogout, useMenu, useGetIdentity } from "@refinedev/core";
import { NavLink } from "react-router-dom";
import { User } from "../../interfaces/user";

export const Menu = () => {
  const { mutate: logout } = useLogout();
  const { menuItems } = useMenu();
  const { data: user } = useGetIdentity<User>();

  // 檢查用戶是否有管理權限
  const hasManagePermission =
    user && ["admin", "maintainer"].includes(user.role);
  const isRegularUser = user && user.role === "user";
  const isAdmin = user && user.role === "admin";

  // 根據用戶角色過濾選單項目
  const filteredMenuItems = menuItems.filter((item) => {
    // 檢查 key、name 或 label 是否包含 View
    const isViewItem =
      item.key === "View" || item.name === "View" || item.label === "View";

    // 檢查是否為用戶管理項目
    const isUserManagementItem =
      item.key === "User" || item.name === "User" || item.label === "User";

    // 如果是一般用戶或 maintainer，只顯示 View 選項
    if (isRegularUser || (user && user.role === 'maintainer')) {
      return isViewItem;
    }

    // User 管理項目只有 admin 可以看到
    if (isUserManagementItem && !isAdmin) {
      return false;
    }

    return true;
  });

  return (
    <nav className="flex flex-col w-full h-full bg-gray-800 text-white">
      <div className="p-4 border-b border-gray-700">
        <h1 className="text-xl font-bold">IMDF Platform</h1>
        {user && (
          <div className="mt-2 text-xs text-gray-400">
            {user.name} ({user.role})
          </div>
        )}
      </div>
      <div className="flex-grow overflow-y-auto">
        <ul className="py-2">
          {filteredMenuItems.map((item) => (
            <li key={item.key} className="px-2">
              <NavLink
                to={item.route ?? "/"}
                className={({ isActive }) =>
                  `flex items-center px-4 py-2 my-1 rounded-md transition-colors ${
                    isActive
                      ? "bg-blue-600 text-white"
                      : "text-gray-300 hover:bg-gray-700"
                  }`
                }
              >
                {item.icon && <span className="mr-3">{item.icon}</span>}
                {item.label}
              </NavLink>
            </li>
          ))}
          
          {/* Profile 選單項目 - user/maintainer 專用 */}
          {(isRegularUser || (user && user.role === 'maintainer')) && (
            <li className="px-2">
              <NavLink
                to="/profile"
                className={({ isActive }) =>
                  `flex items-center px-4 py-2 my-1 rounded-md transition-colors ${
                    isActive
                      ? "bg-blue-600 text-white"
                      : "text-gray-300 hover:bg-gray-700"
                  }`
                }
              >
                <span className="mr-3">👤</span>
                個人資料
              </NavLink>
            </li>
          )}

          {/* 提案審核選單項目 - 僅限 admin */}
          {isAdmin && (
            <li className="px-2">
              <NavLink
                to="/proposals/review"
                className={({ isActive }) =>
                  `flex items-center px-4 py-2 my-1 rounded-md transition-colors ${
                    isActive
                      ? "bg-blue-600 text-white"
                      : "text-gray-300 hover:bg-gray-700"
                  }`
                }
              >
                <span className="mr-3">📋</span>
                提案審核
              </NavLink>
            </li>
          )}
        </ul>
      </div>
      <div className="p-4 border-t border-gray-700">
        <button
          onClick={() => logout()}
          className="w-full px-4 py-2 text-sm text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors"
        >
          登出
        </button>
      </div>
    </nav>
  );
};
